// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Zre_","text":"SelectPayment_text__2X63k","title":"SelectPayment_title__1OlSG","btn":"SelectPayment_btn__2L5JU"};